// extracted by mini-css-extract-plugin
export default {"button":"Ikb_xOlJ9M4X1JxHXqRB","container":"gf8jG53IgsYNaua03lZ3","icon":"fM3e5GhFB89cl_NrT3Zg","buttonContainer":"YiGQiKrlqBXC59E0bNMz","inactive":"i0YXs3BVXXhxzLjz5ZC6"};